import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const DEFAULT_NO_VALUE = '-'

const employeeProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'employee',
  title: i18n.t('documents.employee.list.employee'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ employee }) => {
    const employeeModel = employees.get(employee?.id)
    const userId = employeeModel?.attributes.access_id
    const access = userId ? users.get(userId) : undefined

    if (!access) return <Text.Normal overflowWrap>{DEFAULT_NO_VALUE}</Text.Normal>

    const fullName = employee?.fullName
    const { avatar } = access

    return (
      <Box gap="s8" flexDirection="row" alignItems="center">
        {avatar && fullName && <Avatar label={fullName} url={buildUrl(avatar)} size="s32" />}
        <Text.Normal>{fullName}</Text.Normal>
      </Box>
    )
  },
  colSpan: 2,
})

export default employeeProjection
